import React, { Component } from 'react';
import { connect } from 'react-redux';
import { makeStyles, withStyles } from '@material-ui/core/styles';

import { styled, useTheme } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';

import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Fab from '@mui/material/Fab';
import Popover from '@material-ui/core/Popover';

import { InfoPopover, WelcomeDialog } from './Dialogs';

import MenuIcon from '@mui/icons-material/MenuRounded';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import TuneIcon from '@mui/icons-material/Tune';
import HistoryIcon from '@mui/icons-material/History';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import InfoIcon from '@material-ui/icons/Info';



//-----------------------------------------------------------------



const useStyles = (theme) => ({

    icons: {
        color: '#e8eaf6',
    },

    divider: {
        height: 1,
    },

});


const drawerWidth = 240;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        color: "#111111",
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);

//-----------------------------------------------------------------



class SideBar_ extends Component {

    constructor(props) {
        super(props);

        this.state = {
            openDrawer: false,
            indexPage: 0,
            showPopoverInfo: false,
            anchorEl: null,
        };

    }


    render() {

        const { classes } = this.props;

        const pages = ["New Simulation", "History", "Info"];
        const icons = [<TuneIcon />, <HistoryIcon />, <InfoIcon />];
        var WZL_Logo = "url(" + process.env.PUBLIC_URL + "/res/images/logo_WZL.png)";


        return (
            <div>
                <CssBaseline />

                <Drawer variant="permanent"
                    open={this.state.openDrawer}
                    color="secondary"
                    PaperProps={{
                        sx: {
                            backgroundColor: "primary.main",
                            color: "#ffffff",
                        }, elevation: 8
                    }}>



                    <DrawerHeader>
                        <div
                            style={{
                                display: this.state.openDrawer ? "block" : "none",
                                width: "100%",
                                height: 64,
                                backgroundImage: WZL_Logo,
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "left center",
                                backgroundSize: "contain", filter: "invert(100%)"
                            }}
                        />

                        <Fab
                            elevation={2}
                            size="small"
                            aria-label="edit"
                            onClick={() => {
                                this.setState({ openDrawer: !this.state.openDrawer });
                            }}
                            sx={{
                                mr: 0.4,
                                backgroundColor: "secondary.main",
                                "&:hover": { backgroundColor: "secondary.dark" },
                            }}
                        >
                            <MenuIcon className={classes.icons} />
                        </Fab>
                    </DrawerHeader>

                    <Box sx={{
                        height: 0.001,
                        backgroundColor: "primary.dark",
                    }} />

                    <List>
                        {pages.map((text, index) => (

                            <ListItem key={text} disablePadding
                                onClick={(event) => {
                                    if (index < 2)
                                        this.props.setActivePage(index);
                                    else
                                        this.setState({ showPopoverInfo: true, anchorEl: event.currentTarget });
                                }}
                                sx={{ backgroundColor: (index == this.props.activePage) ? "#336AA8" : "#00000000" }}>

                                <ListItemButton
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: this.state.openDrawer ? 'initial' : 'center',
                                        px: 0.0
                                    }}
                                >

                                    <ListItemIcon
                                        className={classes.icons}
                                        sx={{
                                            minWidth: 0,
                                            mr: this.state.openDrawer ? 3 : 'auto',
                                            ml: 2.5,
                                            justifyContent: 'center',
                                            color: '#ffffff'
                                        }}
                                    >

                                        {icons[index]}

                                    </ListItemIcon>

                                    <ListItemText
                                        primary={text}
                                        sx={{ opacity: this.state.openDrawer ? 1 : 0 }}
                                    />

                                </ListItemButton>

                            </ListItem>

                        ))}
                    </List>

                </Drawer>

                <Popover
                    anchorEl={this.state.anchorEl}
                    open={this.state.showPopoverInfo}
                    onClose={() => { this.setState({ showPopoverInfo: false }); }}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}>

                    <InfoPopover />

                </Popover>

                <WelcomeDialog />


            </div>
        );

    }

}



//-----------------------------------------------------------------



const mapStateToProps = (state, props) => {

    return {
        activePage: state.interaction.activePage,
    };

}

const mapDispatchToProps = (dispatch, props) => {

    return {
        setActivePage: (val) => { dispatch({ type: "PAGE:SET-ACTIVE-PAGE", value: val }) },
    };

}


const SideBar = connect(mapStateToProps, mapDispatchToProps)(SideBar_)
export default withStyles(useStyles)(SideBar);


